import type { ReactElement } from "react";
import { CmtsLoginContainer } from "../../core/containers/domain/authRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsLoginContainer runtime={props.runtime} />;
}

export default Component;
